<template>
  <v-ons-modal
    :visible="showShopDetailScreen"
    :options="{ animation: animation }"
    class="detail-modal desktop-modal"
    @click="detectOutsideClick"
  >
    <shop-details></shop-details>
  </v-ons-modal>
</template>

<script>
import ShopDetails from "./ShopDetails"
import { mapActions, mapGetters } from "vuex"
import detectOutsideClick from "../mixins/detectOutsideClick"

export default {
  computed: {
    animation() {
      return window.innerWidth > 900 ? "fade" : "lift"
    },

    ...mapGetters("nav", ["showShopDetailScreen"])
  },

  methods: {
    cleanupModal() {
      this.setSelectedShopId(null)
    },

    ...mapActions("stores", ["setSelectedShopId"])
  },

  mixins: [detectOutsideClick],

  components: {
    ShopDetails
  }
}
</script>

<style>
@media (min-width: 900px) {
  .detail-modal .close-button {
    position: absolute;
  }
}
</style>
